import * as INR from "../INR.ts";
import * as FwDatas from "../FwDatas.ts";
import * as libLocation from "../lib/location.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";
import * as modal from "../util/modal.ts";
import {ControllerBook} from "../page/ControllerBook.ts";

import SPECIALDAYS_LIST_TEMPLATE from "./specialdays_list.mustache";
import SPECIALDAYS_DETAILS_TEMPLATE from "./specialdays_details.mustache";
import TPL_RIGHT_EMPTY from "./specialdays_empty.mustache";
import "./ui_specialdays.ts";
import * as FeatureSeen from "../util/FeatureSeen.ts";

import { getSpecialdaysCache, specialDaysFoldered } from "./common_specialdays.ts";
import Icons from "../svg/Icons.ts";
import { editMemberBidthday } from "./ui_specialdays.ts";

actionMenu.register({
  async specialdaysmainmenu(){
    const
      menu = [];

    menu.push({svg:Icons.ic_add_event,onclick:"specialdayscreate",i18nkey:'specialdays.actions.add'})
    menu.push({svg:Icons.ic_comment,  async clickFunction(){
      var TPL_FEEDBACK = await import("../modal/feedbacks.mustache");
      modal.openDomModal(TPL_FEEDBACK,{description:'feedback.specialdays',type:"SPECIAL_DAYS"})
    },i18nkey:'actions.feedback'})

    return {menu}
  }
})


INR.onPage(INR.URL.SPECIALDAYS,function(){
  //can be accessed only by premium users
  if(FwDatas.getPermission('specialDays')!=='OK'){
    libLocation.goTo(INR.URL.ENTER_HOME);
    return;
  }

  if(!FeatureSeen.hasSeen('specialdays.onboarding')){
    FeatureSeen.markSeen('specialdays.onboarding');
    modal.askAsPromise({
      cover:"images/illustration_cover_special_days_horizontal.svg",
      h1:"specialdays.onboarding.title",
      message:"specialdays.onboarding.text",
      button:[{title:'actions.start'}]
    }).then(async ()=>{
      const membersWithoutBirthday = (FwDatas.getFamily().members.filter(m=>m.birthDate==undefined && m.isEditable))
      if(membersWithoutBirthday.length>0){
        editMemberBidthday(membersWithoutBirthday)
      }

    })
  }

  var
    CONTROLLER,
    displayContext = {search:''};

  var {SpecialDayCache,SpecialDayInstanceCache} = getSpecialdaysCache()


  async function datachanged(){
    CONTROLLER.refresh()
  }
  INR.subscribe("eventCreated contactCreated eventUpdated contactUpdated memberUpdated eventDeleted contactDeleted",datachanged);


  CONTROLLER = new ControllerBook(
    document.getElementById('specialdays-list-container'),
    SPECIALDAYS_LIST_TEMPLATE,
    document.querySelector(".pane-main"),
    SPECIALDAYS_DETAILS_TEMPLATE,
    TPL_RIGHT_EMPTY,
    SpecialDayInstanceCache,
    async ()=>{
      return await specialDaysFoldered(SpecialDayInstanceCache,displayContext)
    }
  );
  document.querySelector('.pane-left *[name=search]')?.addEventListener('input',function(this:HTMLInputElement){
    displayContext.search = this.value;
    CONTROLLER.refresh()
  })


});
